import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

export interface ExpDeteminationFormGroup {
  minGrossIncome: FormControl<boolean>;
  atLeastOneYerExp: FormControl<boolean>;
  experienced: FormControl<boolean>;
  validStatements: FormControl<boolean>;
}

export function getExpDeteminationFormGroup(
  fb: FormBuilder
): FormGroup<ExpDeteminationFormGroup> {
  return fb.nonNullable.group({
    minGrossIncome: fb.nonNullable.control(false),
    atLeastOneYerExp: fb.nonNullable.control(false),
    experienced: fb.nonNullable.control(false),
    validStatements: fb.nonNullable.control(false, Validators.requiredTrue),
  });
}
